// extracted by mini-css-extract-plugin
export default {"descriptionBox":"styles_descriptionBox__0oJsN","subTitle":"styles_subTitle__mrboE"};